/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import NewsletterModel from 'cio/models/newsletter';
import SubscriptionCenterService from 'cio/services/subscription-center';
import { isEmpty } from '@ember/utils';

interface NewsletterRecipientsSummaryArgs {
  model: NewsletterModel;
  tense?: string;
  isReady?: boolean;
}

const RECIPIENT_TYPES = ['everyone', 'subset', 'csv'];

export default class NewsletterRecipientsSummary extends Component<NewsletterRecipientsSummaryArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;

  constructor(owner: unknown, args: NewsletterRecipientsSummaryArgs) {
    super(owner, args);

    this.subscriptionCenter.initializeTask.perform();
  }

  get isPastTense() {
    return this.args.tense === 'past';
  }

  get isFutureTense() {
    return !this.isPastTense;
  }

  get tense() {
    return this.args.tense ?? 'past';
  }

  get isReady() {
    return this.args.isReady ?? true;
  }

  get unknownRecipients() {
    return !RECIPIENT_TYPES.includes(this.args.model.recipientType ?? '');
  }

  get sendingToOnePerson() {
    let { sendPercentage, sendingTotalPeople, recipients } = this.args.model;

    return (sendPercentage === 100 && sendingTotalPeople === 1) || recipients.total === 1;
  }

  get topicName() {
    if (this.args.model.subscriptionTopicId == null || !this.subscriptionCenter.initialized) {
      return null;
    }

    return this.subscriptionCenter.topics.find((topic) => topic.id === this.args.model.subscriptionTopicId)?.name;
  }

  get isCountedTowardsMessageLimit() {
    return this.args.model.useMessageLimits;
  }

  get isUsingRateLimit() {
    return !isEmpty(this.args.model.rateLimitEnabled);
  }

  get rateLimitTimePeriod() {
    switch (this.args.model.rateLimitTimePeriod) {
      case 60:
        return 'minute';
      case 3600:
        return 'hour';
      case 86400:
        return 'day';
      default:
        return;
    }
  }
}
